<script type="text/javascript">
	import SpinnerSize from './SpinnerSize.js'
	export let absolute = true;
	export let inline = false;
	export let size = SpinnerSize.NORMAL;
	export let percentage = "";
</script>

<style>
	@keyframes Spinner {
		0% {
			transform: rotate(0deg);
		}
		100% {
			transform: rotate(360deg);
		}
	}

	div.spinnerContainer {
		display: block;
		z-index: 1001;
	}
	div.spinnerContainer.absolute {
		display: block;
		position:absolute;
		left:50%;
		top:50%;
		z-index: 1002;
		margin-left: -32px;
		margin-top: -32px;
	}
	div.spinnerContainer.inline {
		position:relative;
		display:inline-block;
		left:0;
		padding: 10px;
	}


	div.spinnerCircle {
		animation: 400ms linear infinite Spinner;
		border-radius: 50%;
		border-bottom: 3px solid transparent;
		border-left: 3px solid var(--mdc-theme-primary, #3a96b8);
		border-right: 3px solid transparent;
		border-top: 3px solid var(--mdc-theme-primary, #3a96b8);
		box-sizing: border-box;
		height: 64px;
		width: 64px;
	}
	div.spinnerContainer p {
		color: white;
		font-weight: bold;
		line-height:32px;
		margin-top:-48px;
		text-align:center;
	}

	div.spinnerContainer.sml {
		margin-left: -16px;
		margin-top: -16px;
	}
	div.spinnerContainer.sml div.spinnerCircle {
		width:32px;
		height:32px;
	}
	div.spinnerContainer.sml p {
		color: white;
		font-weight: bold;
		line-height:32px;
		margin-top:-48px;
		text-align:center;
	}

	div.spinnerContainer.mini {
		margin-left: -8px;
		margin-top: -8px;
	}
	div.spinnerContainer.mini div.spinnerCircle {
		width:16px;
		height:16px;
	}
	div.spinnerContainer.mini p {
		color: white;
		font-weight: bold;
		line-height:16px;
		margin-top:-24px;
		text-align:center;
	}
</style>

<div class={"spinnerContainer" + ((absolute)?" absolute":"") + " " + ((inline)?" inline":"") + " " + size}>
	<div class='spinnerCircle'></div>
	<p>{percentage}</p>
</div>
